
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ar",
      function () {
        return require("private-next-pages/ar/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ar"])
      });
    }
  